import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=c6423cfa&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=c6423cfa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6423cfa",
  null
  
)

export default component.exports